import { constants } from '..';

const INITIAL_STATE = {
  loading: false,
  total: 0,
  header: {},
  loyaltyPrograms: [],
  selectedLoyaltyProgram: null,
};

export const loyaltyProgramReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.loyaltyProgram.SET_LOYALTY_PROGRAMS_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.loyaltyProgram.SET_LOYALTY_PROGRAMS:
      return {
        ...state,
        loyaltyPrograms: action.loyaltyPrograms,
        header: action.header,
        total: action.count,
      };
    case constants.loyaltyProgram.CLEAR_LOYALTY_PROGRAMS:
      return {
        ...INITIAL_STATE,
      };
    case constants.loyaltyProgram.SET_LOYALTY_PROGRAM:
      return {
        ...state,
        selectedLoyaltyProgram: action.loyaltyProgram,
      };
    default:
      return state;
  }
};
